import { styled } from "@mui/material/styles";

export const UploadLink = styled("span")(({ theme }) => ({
  cursor: "pointer",
  fontSize: "12px",
  fontWeight: "bold",
}));
